import {Component, OnDestroy, OnInit} from '@angular/core'
import {NbMediaBreakpointsService, NbMenuItem, NbMenuService, NbSidebarService, NbThemeService, NbDialogService} from '@nebular/theme'
import {Subject} from 'rxjs'
import {map, takeUntil} from 'rxjs/operators'
import {extract, I18nService} from '../../../@core/translate/i18n.service'
import {LayoutService} from '../../../@core/utils'
import {AuthService} from '../../../auth/auth.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>()
  userPictureOnly: boolean = false
  user: any

  themes: Array<{value: string, name: string}> = [
    {value: 'default', name: 'Light'},
    {value: 'dark', name: 'Dark'},
    {value: 'cosmic', name: 'Cosmic'},
    {value: 'corporate', name: 'Corporate'},
  ]

  currentTheme: string = 'default'

  userMenu: NbMenuItem[] = []
  reminderMenu: NbMenuItem[] = []

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: AuthService,
    private i18nService: I18nService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.userMenu = [
      // {title: extract('header.menu.profile'), link: '/app/admin-users/profile'},
      {title: extract('header.menu.logout'), link: '/auth/logout'}
    ].map(i => this.translateTitle(i))

    this.user = this.authService.user
    // this.currentTheme = this.themeService.currentTheme


    const {xl} = this.breakpointService.getBreakpointsMap()
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl)

    this.themeService.onThemeChange()
      .pipe(
        map(({name}) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName)
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName)
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar')
    this.layoutService.changeLayoutSize()

    return false
  }

  navigateHome() {
    this.menuService.navigateHome()
    return false
  }

  private translateTitle(i: NbMenuItem) {
    i.title = this.i18nService.tr(i.title)
    return i
  }
}
